<template>
  <footer class="pt-8 md:pt-16 bg-backgroundColor">
    <div class="flex flex-col items-center py-6 bg-white">
      <div class="w-[94%] md:w-[75%] 2xl:w-[60%]">
        <!-- Logo and Contact Info -->
        <div class="pb-6">
          <!-- Contact and Social -->
          <div
            class="flex flex-col md:flex-row justify-between pt-6 space-y-6 md:space-y-0"
          >
            <!-- Contact Info -->
            <ul class="space-y-3 text-sm text-gray-700 md:w-1/2">
              <h3 class="text-sm font-semibold text-gray-800">Contact Us</h3>
              <li 
  class="flex items-start cursor-pointer"
  v-for="item in items" 
  :key="item.id"
  @click="handleClick(item)"
>
  <img :src="item.imageUrl" class="w-6 h-6 object-contain" alt="" />
  <span class="pl-3">{{ item.name }}</span>
</li>
            </ul>
            <ul class="space-y-3 text-sm text-gray-700 ">
              <h3 class="text-sm font-semibold text-gray-800">Quick Link</h3>
              <router-link  to="/contact-us"><li class="mt-3">Contact Us</li></router-link>
              <router-link  to="/news-event"><li class="mt-3">News & Event</li></router-link>
            </ul>
            <!-- Social Media -->
            <div>
              <h3 class="text-sm font-semibold text-gray-800">Follow Us</h3>
              <ul class="flex items-center pt-3 space-x-4">
                <li v-for="social in dataSocialLinks" :key="social.id">
                  <template v-if="social.name">
                    <a :href="social.name" target="_blank" rel="noopener">
                      <img
                        class="w-auto h-[24px] object-contain transition"
                        :src="social.icon"
                      />
                    </a>
                  </template>
                  <template v-else>
                    <img
                      class="w-auto h-[24px] object-contain cursor-default"
                      :src="social.icon"
                    />
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Copyright -->
        <div class="border-t pt-4">
          <p class="text-xs text-gray-500">
            {{ copyRightText }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";

export default {
  name: "MainFooter",
  data() {
    return {
      copyRightText: "",
      items: [],
      dataSocialLinks: [],
    };
  },
  mounted() {
    this.fetchCopyRight();
    this.fetchContactUs();
    this.fetchSocial();
  },
  methods: {
    async fetchCopyRight() {
      try {
        const q = query(
          collection(db, "copyRight"),
          orderBy("createdAt", "desc"),
          limit(1)
        );
        const snapshot = await getDocs(q);
        if (!snapshot.empty) {
          this.copyRightText = snapshot.docs[0].data().name;
        }
      } catch (error) {
        console.error("Error fetching copyright:", error);
      }
    },
    async fetchContactUs() {
      const q = query(collection(db, "contactUs"), orderBy("orderNumber", "asc"));
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
    handleClick(item) {
      if (item.name && item.name.includes("@")) {
        window.location.href = `mailto:${item.name}`;
      }
    },
    async fetchSocial() {
      const socialQuery = query(
        collection(db, "socialLinks"),
        orderBy("orderNumber", "asc")
      );
      const socialSnap = await getDocs(socialQuery);
      this.dataSocialLinks = socialSnap.docs.map((doc) => ({
        ...doc.data(),
      }));
    },
  },
};
</script>
